import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectssmartworld } from "../../../../data/projects/smartworld/data";

export const SmartWorldSkyArc = () => {
  const {
    smartworld_skyarc: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectssmartworld;

  return (
    <>
      <Helmet>
        <title>Smartworld Skyarc, Sector 69, Gurgaon | Luxury High-Rise Residences</title>

        <meta
          name="description"
          content="Discover Smartworld Skyarc in Sector 69, Gurgaon – a premium high-rise residential project featuring luxury apartments, world-class amenities, and seamless connectivity. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="Smartworld Skyarc, Smartworld Skyarc Sector 69 Gurgaon, Smartworld Skyarc apartments, luxury residences Gurgaon, Smartworld Skyarc price, Smartworld Skyarc floor plan, high-rise apartments Gurgaon, premium homes in Gurgaon"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/smartworld-skyarc-sector-69-gurgaon/"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
